export const configFastOrder = {
  defaultEmail: 'pick-up-in-store-koleso@koleso.ru',
  minQtyIsHideShopTwoHours: 4,
  minPriceIsHideShopTwoHours: 13_000,
};
